'use client';

import Avatar from '@/components/next-ui/Avatar';
import { NEKI_LOGO_S3_URL } from '@/constants/neki.constant';
import OrgType from '@/constants/orgType.constant';
import { CommunityRoles } from '@/utils/communityRoles';
import getQualifiedImageUrl from '@/utils/imageUrlProcessor';
import { getAdminLoginUrl } from '@/utils/stringHelpers';
import { useUser } from '@auth0/nextjs-auth0/client';
import { Disclosure } from '@headlessui/react';
import FadeTransition from '@ui/Transitions/FadeTransition';
import Typography from '@ui/Typography';
import { cx } from 'class-variance-authority';
import { kebabCase, last } from 'lodash-es';
import Image from 'next/image';
import Link from 'next/link';
import React from 'react';
import { MdOutlineKeyboardArrowDown } from 'react-icons/md';

function MyCommunity(props) {
  const { community: userActiveCommunity, user, accessToken } = props;
  const isCommunityAdmin = userActiveCommunity?.role === CommunityRoles.Admin;
  const isNonProfitAdmin =
    isCommunityAdmin && userActiveCommunity?.orgType === OrgType.NonProfit;
  const hasPublicProfile = userActiveCommunity?.publicProfile?.enabled;

  const isCompanyCommunity = [OrgType.Business, OrgType.ChangeMakers].includes(
    userActiveCommunity?.orgType,
  );
  const isNonProfitCommunity =
    userActiveCommunity?.orgType === OrgType.NonProfit;

  const hasPublicCompanyProfile = hasPublicProfile && isCompanyCommunity;
  const showHomeAnalytics =
    isCommunityAdmin && (isNonProfitCommunity || hasPublicCompanyProfile);

  const primaryCommunity = userActiveCommunity?.primaryCommunity;

  // if (!hasPublicProfile && !isNonProfitAdmin && !isCommunityAdmin) {
  //   return null;
  // }

  const nekiAdminLoginUrl = getAdminLoginUrl(user?.email, accessToken);

  const getNonProfitLink = () => {
    if (isNonProfitAdmin) {
      let slug = hasPublicProfile
        ? last(userActiveCommunity.publicProfile.slug?.split('/'))
        : null;

      if (!slug) {
        slug = `${kebabCase(userActiveCommunity?.name)}-${
          userActiveCommunity?.nonProfit?.id
        }`;
      }
      return `/organization/${slug}`;
    }
    return null;
  };

  const getCommunityLogoUrl = (community) => {
    if (community.logoUrl) {
      return getQualifiedImageUrl(community.logoUrl);
    }
    return NEKI_LOGO_S3_URL;
  };

  return (
    <div className="relative flex flex-col">
      {primaryCommunity && (
        <div className="relative">
          <div className="flex items-center gap-2">
            <Avatar
              src={getCommunityLogoUrl(primaryCommunity)}
              alt={primaryCommunity.name}
              profile="company"
              className="h-10 w-10"
            />
            <Typography
              title={primaryCommunity.name}
              variant="h3"
              component="span"
              className="truncate text-left">
              {primaryCommunity.name && primaryCommunity.name.length > 16
                ? `${primaryCommunity.name.slice(0, 16)}...`
                : primaryCommunity.name}
            </Typography>
          </div>

          <div className="absolute left-5 top-[64px] h-px w-6 bg-gray-500" />
          <div className="absolute left-5 top-10 h-6 w-px bg-gray-500" />
        </div>
      )}

      {userActiveCommunity && (
        <div className={cx(primaryCommunity && 'ml-12 mt-2')}>
          <div className="flex items-center gap-2">
            <Avatar
              src={getCommunityLogoUrl(userActiveCommunity)}
              alt={userActiveCommunity.name}
              profile="company"
              className="h-10 w-10"
            />
            <Typography
              title={userActiveCommunity.name}
              variant="h3"
              component="span"
              className="truncate text-left">
              {userActiveCommunity.name && userActiveCommunity.name.length > 16
                ? `${userActiveCommunity.name.slice(0, 16)}...`
                : userActiveCommunity.name}
            </Typography>
          </div>

          <div className="ml-2 mt-4 flex flex-col items-start gap-2">
            {hasPublicProfile && (
              <Link href={`/${userActiveCommunity.publicProfile.slug}`}>
                <Typography
                  variant="subtitle1"
                  className="hover:text-text-hyperlink">
                  Public Page
                </Typography>
              </Link>
            )}
            {isNonProfitAdmin && (
              <Link href={getNonProfitLink()}>
                <Typography
                  variant="subtitle1"
                  className="hover:text-text-hyperlink">
                  My Non Profit
                </Typography>
              </Link>
            )}
            {isCommunityAdmin && (
              <Typography
                component="a"
                href={nekiAdminLoginUrl}
                variant="subtitle1"
                className="hover:text-text-hyperlink">
                Administration
              </Typography>
            )}
            {showHomeAnalytics && (
              <Link href={`/analytics`}>
                <Typography
                  variant="subtitle1"
                  className="hover:text-text-hyperlink">
                  Analytics
                </Typography>
              </Link>
            )}
          </div>
        </div>
      )}
    </div>
  );

  // return (
  //   <Disclosure defaultOpen>
  //     {({ open }) => (
  //       <>
  //         <Disclosure.Button className="flex w-full items-center justify-between">
  //           <div className="flex items-center justify-start gap-2">
  //             {/* <Image
  //               width={40}
  //               height={40}
  //               src="/assets/icons/my-communities.svg"
  //               alt="my community"
  //               className="h-10 w-10"
  //             /> */}
  //             <Typography variant="h3" className="text-left">
  //               My Community
  //             </Typography>
  //           </div>
  //           {/* <MdOutlineKeyboardArrowDown
  //             className={`${
  //               open ? 'rotate-180 transform' : ''
  //             } h-5 w-5 text-text-secondary`}
  //           /> */}
  //         </Disclosure.Button>
  //         <FadeTransition>
  //           <Disclosure.Panel className="ml-2 flex flex-col items-start justify-start gap-2 last:gap-0">
  //             {hasPublicProfile && (
  //               <Link href={`/${userActiveCommunity.publicProfile.slug}`}>
  //                 <Typography
  //                   variant="subtitle1"
  //                   className="hover:text-text-hyperlink">
  //                   Public Page
  //                 </Typography>
  //               </Link>
  //             )}
  //             {isNonProfitAdmin && (
  //               <Link href={getNonProfitLink()}>
  //                 <Typography
  //                   variant="subtitle1"
  //                   className="hover:text-text-hyperlink">
  //                   My Non Profit
  //                 </Typography>
  //               </Link>
  //             )}
  //             {isCommunityAdmin && (
  //               <Typography
  //                 component="a"
  //                 href={process.env.NEXT_PUBLIC_ADMIN_APP_URL}
  //                 variant="subtitle1"
  //                 className="hover:text-text-hyperlink">
  //                 Administration
  //               </Typography>
  //             )}
  //           </Disclosure.Panel>
  //         </FadeTransition>
  //       </>
  //     )}
  //   </Disclosure>
  // );
}

export default React.memo(MyCommunity);
